export const AT_RISK_STEP_ID = {
    INITIAL: 'initial',
    A_BIT_STUCK: 'a_bit_stuck',
    A_LITTLE_CONFUSED: 'a_little_confused',
    TIRED: 'tired',
    OVERWHELMED: 'overwhelmed',
    SOMETHING_ELSE: 'something_else',
    CONFIRMATION: 'confirmation',
} as const;

// Maps each option text_code to the step it leads to.
// pretty_good is intentionally absent — that path submits then closes the modal with no response step.
// confused is the text_code returned by the API for the "A little confused" option.
export const OPTION_TO_STEP_ID: Record<string, string> = {
    a_bit_stuck: AT_RISK_STEP_ID.A_BIT_STUCK,
    confused: AT_RISK_STEP_ID.A_LITTLE_CONFUSED,
    tired: AT_RISK_STEP_ID.TIRED,
    overwhelmed: AT_RISK_STEP_ID.OVERWHELMED,
    something_else: AT_RISK_STEP_ID.SOMETHING_ELSE,
};

// Progress bar value (0–100) shown at each step
export const STEP_PROGRESS: Record<string, number> = {
    [AT_RISK_STEP_ID.INITIAL]: 0,
    [AT_RISK_STEP_ID.A_BIT_STUCK]: 100,
    [AT_RISK_STEP_ID.A_LITTLE_CONFUSED]: 100,
    [AT_RISK_STEP_ID.TIRED]: 100,
    [AT_RISK_STEP_ID.OVERWHELMED]: 100,
    [AT_RISK_STEP_ID.SOMETHING_ELSE]: 50,
    [AT_RISK_STEP_ID.CONFIRMATION]: 100,
};

export const FREEFORM_MAX_CHARS = 500;
